import React from 'react';
import { createRoot } from 'react-dom/client';
import CssBaseline from '@material-ui/core/CssBaseline';

import App from './App';

if (process.env.NODE_ENV === 'development') {
	const originalError = console.error;
	console.error = (...args) => {
		const msg = typeof args[0] === 'string' ? args[0] : '';
		if (
			msg.includes('key') && msg.includes('list') ||
			msg.includes('defaultProps will be removed') ||
			msg.includes('findDOMNode is deprecated')
		) return;
		originalError.apply(console, args);
	};
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
	<CssBaseline>
		<App />
	</CssBaseline>,
);
